import * as React from "react"
import { Progress } from "@/components/ui/progress"
import { cn } from "@/lib/utils"

interface AgingBarProps {
  label: string
  amount: string
  percentage: number
  color: "green" | "yellow" | "orange" | "lightRed" | "darkRed"
}

const colorStyles = {
  green: { 
    dot: "bg-green-500", 
    bar: "[&>div]:bg-green-500" 
  },
  yellow: { 
    dot: "bg-yellow-500", 
    bar: "[&>div]:bg-yellow-500" 
  },
  orange: { 
    dot: "bg-orange-500", 
    bar: "[&>div]:bg-orange-500" 
  },
  lightRed: { 
    dot: "bg-red-400", 
    bar: "[&>div]:bg-red-400" 
  },
  darkRed: { 
    dot: "bg-red-600", 
    bar: "[&>div]:bg-red-600" 
  },
}

export function AgingBar({ label, amount, percentage, color }: AgingBarProps) {
  const styles = colorStyles[color]

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className={cn("h-2 w-2 rounded-full", styles.dot)} />
          <span className="text-sm font-medium">{label}</span>
        </div>
        <span className="text-sm font-semibold">{amount}</span>
      </div>
      <div className="flex items-center gap-2">
        <Progress value={percentage} className={cn("h-2", styles.bar)} />
        <span className="text-xs text-muted-foreground min-w-[3rem] text-right">
          {percentage}%
        </span>
      </div>
    </div>
  )
}
